import React, { FC } from "react";
const Loading: FC = () => {
  return (
    <>
      <h1>loading</h1>
    </>
  );
};
export default Loading;
